import { Box, FormControl, FormHelperText, Switch } from '@mui/material'
import loGet from 'lodash/get'
import React, { useEffect } from 'react'
import { Control, Controller, FieldErrorsImpl } from 'react-hook-form'
import { useAppDispatch } from 'state/hooks'
import { fetchChains } from 'state/chain/reducer'
import { DefaultValueMap } from '..'

type DropdownProps = {
  name: string
  label?: string
  isRequired?: boolean
  disabled?: boolean
  control?: Control<DefaultValueMap, any>
  errors: FieldErrorsImpl<{
    [x: string]: any
  }>
  minWidth?: string
  fullWidth?: boolean
}

const Dropdown: React.FC<DropdownProps> = ({
  name,
  control,
  isRequired,
  label,
  errors,
  minWidth,
  fullWidth,
}) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchChains())
  }, [dispatch])

  return (
    <Controller
      control={control}
      name={name}
      rules={isRequired ? { required: 'This field is required.' } : {}}
      render={({ field }) => (
        <>
          <FormControl
            variant="filled"
            sx={{ minWidth: minWidth || (fullWidth ? '100%' : 340) }}
            error={!!loGet(errors, name)}
            fullWidth={fullWidth}
          >
            <Box
              style={{ marginBottom: 4, color: 'rgba(255, 255, 255, 0.7)' }}
              sx={{
                wordBreak: 'break-word',
                whiteSpace: 'normal',
              }}
            >
              {label}
            </Box>
            <Switch
              value={field.value}
              checked={field.value}
              onChange={(_, val) => {
                console.log(val, field, 'wuwuuw')
                field.onChange(val)
              }}
              data-testid={`switch-${name}`}
            />
            <FormHelperText>
              {loGet(errors, name)?.message as string}
            </FormHelperText>
          </FormControl>
        </>
      )}
    />
  )
}

export default Dropdown
